import { render, staticRenderFns } from "./ArticleCardSave.vue?vue&type=template&id=26d9e583&scoped=true"
import script from "./ArticleCardSave.vue?vue&type=script&lang=js"
export * from "./ArticleCardSave.vue?vue&type=script&lang=js"
import style0 from "./ArticleCardSave.vue?vue&type=style&index=0&id=26d9e583&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d9e583",
  null
  
)

export default component.exports